import React from "react";
import { Box } from "@mui/material";

// Rounded tile that houses a section-header icon. Grey by default (matches the
// Figma section headers). Pass a `currentColor` SVG glyph as `icon`; the tile's
// `color` drives the glyph color so one component covers all sections.
export default function SectionIconTile({
    icon,
    tileBg = "#F3F5F7",
    iconColor = "#62748E",
    size = 40,
}) {
    return (
        <Box
            sx={{
                width: size,
                height: size,
                borderRadius: "10px",
                backgroundColor: tileBg,
                color: iconColor,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
            }}
        >
            {icon}
        </Box>
    );
}
